import styled from 'styled-components';

/** A round flag (the picture is already a disc). */
export const FlagImg = styled.img`
  display: block;
  flex: none;
  border-radius: 50%;
`;
